// removed by extract-text-webpack-plugin
module.exports = {"position-indicator__container":"dh-dh-plast-quiz-position-indicator__container","position-indicator":"dh-dh-plast-quiz-position-indicator"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/Overlay/PositionIndicator.css
// module id = 63
// module chunks = 0